import { render, staticRenderFns } from "./BusinessCaseSb.vue?vue&type=template&id=b891f22e&scoped=true"
import script from "./BusinessCaseSb.vue?vue&type=script&lang=js"
export * from "./BusinessCaseSb.vue?vue&type=script&lang=js"
import style0 from "./BusinessCaseSb.vue?vue&type=style&index=0&id=b891f22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b891f22e",
  null
  
)

export default component.exports